import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, } from '@angular/material/dialog';
import { EmailVerificationComponent } from 'src/app/modules/registration/components/email-verification/email-verification.component';
import { LinkAccountDialogComponent } from 'src/app/modules/registration/components/link-account-dialog/link-account-dialog.component';
import { RegistationUtilitiesService } from 'src/app/modules/registration/services/registation-utilities.service';
import { ApiService } from 'src/app/services/apiService/api.service';
import { AuthServiceService } from 'src/app/services/authService/auth-service.service';
import { CamService } from 'src/app/services/camService/cam.service';
import { CommonService } from 'src/app/shared/common/common.service';
import { environment } from 'src/environments/environment';
import { MatIcon } from '@angular/material/icon';
import { NgSelectComponent, NgOptgroupTemplateDirective, NgOptionTemplateDirective, NgLabelTemplateDirective, NgNotFoundTemplateDirective } from '@ng-select/ng-select';
import { AutoBlurSelectDirective } from '../../../directive/auto-select-blur.directive';
import { NgIf } from '@angular/common';
import { MatFormField, MatLabel, MatSuffix, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ToastrApiService } from 'src/app/shared/common/toastr-api.service';
@Component({
  selector: 'app-contact-update-dialog',
  templateUrl: './contact-update-dialog.component.html',
  styleUrls: ['./contact-update-dialog.component.scss'],
  imports: [MatIcon, ReactiveFormsModule, NgSelectComponent, AutoBlurSelectDirective, NgOptgroupTemplateDirective, NgOptionTemplateDirective, NgLabelTemplateDirective, NgNotFoundTemplateDirective, MatFormField, MatLabel, MatInput, MatSuffix, MatError, MatButton, MatProgressSpinner,],
})
export class ContactUpdateDialogComponent implements OnInit {
  public _siteCoreBaseUrl = environment.siteCoreBaseUrl;
  countriesLists: any[] = [];
  updateMobileNumber!: FormGroup;
  ciamToken!: any;
  b2bUserCustomerType:any;
  Loader: any = {
    isSpinner: false,
    isEditableClicked: false,
  };
  constructor(
    public dialogRef: MatDialogRef<ContactUpdateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    public _CommonService: CommonService,
    private _ApiService: ApiService,
    private fb: FormBuilder,
    private _CamApiService: CamService,
    private MatDialog: MatDialog,
    private authService: AuthServiceService,
    private readonly _ToastrApiService: ToastrApiService,
    private readonly _RegistationUtilitiesService: RegistationUtilitiesService
  ) {
    this.updateMobileNumber = this.fb.group({
      countryCode: [null, Validators.required],
      mobileNumber: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(12),],],
    });
  }

  ngOnInit(): void {
    this.authService.getTokenbeforeLogin().subscribe((res: any) => {
      const tokenData = res.data;
      localStorage.setItem('token_type', tokenData.token_type);
      localStorage.setItem('access_token', tokenData.access_token);
      localStorage.setItem('expires_in', tokenData.expires_in);
      localStorage.setItem('session_id', tokenData.session_id);
      localStorage.setItem('scope', tokenData.scope);
    });
    this._ApiService.getCountriesData().then(($res) => {
      this.countriesLists = this._CommonService.groupCountriesFilter($res);
    }).catch(($err) => { });
    this.updateMobileNumber.patchValue({
      countryCode: this.dialogData.countryId,
      mobileNumber: this.dialogData.mobile,
    });

    this.updatePhoneNumberValidators();
    this.updateMobileNumber.get('countryCode')?.valueChanges.subscribe(() => {
      this.updatePhoneNumberValidators();
    });

    this.ciamToken = this.dialogData.ciamToken;
  }

  updatePhoneNumberValidators() {
    const phoneControl = this.updateMobileNumber.get('mobileNumber');
    const countryCode = this.updateMobileNumber.get('countryCode')?.value;
    
    // Check if India (ISD code +91 or 91)
    const isIndia = countryCode === '+91' || countryCode === '91';
 
    if (isIndia) {
      // India: exactly 10 digits
      phoneControl?.setValidators([
        Validators.required,
        Validators.pattern(/^\d{10}$/),
      ]);
    } else {
      // Other countries: 6 to 12 digits
      phoneControl?.setValidators([
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(12)
      ]);
    }
 
    phoneControl?.updateValueAndValidity();
  }

  getImageUrl(path: string): string {
    if (!path) return '';
    const base = this._siteCoreBaseUrl?.replace(/\/+$/, '') || '';
    const cleanPath = path.replace(/^\/+/, '');
    return `${base}/${cleanPath}`;
  }

  blockInvalidCharacters(event: KeyboardEvent): void {
    const invalidChars = ['<', '>', '$', ' ', ',', '.', '~', '/', '"', "'", '`', '_', '-', '@', '%', '|', '+', ';', '[', ']', ':', '--', '\\', '?', '#', '&', '^', '*', '!', '=', '(', ')', '{', '}',];
    const isAlphabet = /^[a-zA-Z]$/.test(event.key);
    const currentInputLength = (event.target as HTMLInputElement).value.length;
    if (currentInputLength >= 12) {
      event.preventDefault();
      return;
    }
    if (isAlphabet || invalidChars.includes(event.key)) {
      event.preventDefault();
    }
  }

  onSave() {
    this.Loader.isSpinner = true;
    this.getb2bUserProfileType();
  }

  getb2bUserProfileType() {
    const ciamid = localStorage.getItem('CIAMID');
    const crmId = localStorage.getItem('CRMID') || '';
    const email= localStorage.getItem('email') || '';
    const pload = {
       ciamId: ciamid,
       crmId:crmId,
       emailAddress:email
       };
    
    this._CamApiService.b2bUserProfileType(pload).subscribe({
      next: (response: any) => {
        console.log('b2bUserProfileType response', response);
        this.b2bUserCustomerType=response?.data?.customerType;
        this.fetchMatchProfileApi();
      },
      error: (err: any) => {
        this.Loader.isSpinner = false;
        console.error('Error creating phoneVerifiedCiam', err);
        this._ToastrApiService.show('error',  err?.error?.message);
        this.dialogRef.close();
      }
    });
  }

  fetchMatchProfileApi() {
    this.Loader.isSpinner = true;
    const sessionID = localStorage.getItem('session_id');
    const token = localStorage.getItem('access_token');
    const mobile = this.updateMobileNumber.get('mobileNumber')?.value;
    const code = this.updateMobileNumber.get('countryCode')?.value;
    const crmId = localStorage.getItem('CRMID') || '';
  
    const matchPayload = {
      
        matchPreferences: {
            contactId: crmId,
            isProfileUpdate: true,
            sourceProfile: `[${this.b2bUserCustomerType}]`
        },
      mobile: `${code}${mobile}`,
    };

    this._RegistationUtilitiesService.fetchMatching(sessionID, token, matchPayload).subscribe({
      next: (res: any) => {
        const hasMatch = Array.isArray(res?.data?.matchedContacts) && res?.data?.matchedContacts.length > 0;
       
        if (hasMatch) {
          this.Loader.isSpinner = false;
          this.dialogRef.close();
          this.MatDialog.open(LinkAccountDialogComponent, {
            disableClose: true,
            data: {
              matches: res.data,
              data: this.updateMobileNumber.getRawValue(),
              method: 'beforeLoginCIAMmobileMatch',
              ciamID: this.dialogData.ciamToken,
              secondaryContactID: this.dialogData.contactId,
              // loginCustomerTypd: this.customerTypes
            },
          });
        } else {
          this.beforeLoginCIAMmobileMatchAPI();
        }
      },
      error: (err: any) => {
        this.Loader.isSpinner = false;
        console.error('Error fetching matching contacts', err);
        this.beforeLoginCIAMmobileMatchAPI();
      }
    });
  }

  beforeLoginCIAMmobileMatchAPI() {
    const formValue = this.updateMobileNumber.value;
    const phoneNumber = `${formValue.countryCode}${formValue.mobileNumber}`;
    const payload = {
      // type: 'phone',
      phone_number: phoneNumber,
      //preferred_authentication_method: 'sms'
    };

    this.Loader.isSpinner = true;

    this._CamApiService.phoneVerification(payload).subscribe({
      next: (res: any) => {
        this.Loader.isSpinner = false;
        const authSession = res?.data?.auth_session;
        const phoneId = res?.data?.id;
        setTimeout(() => {
          const emailDialog = this.MatDialog.open(EmailVerificationComponent, {
            data: {
              PhoneNumber: formValue.mobileNumber,
              isdCode: formValue.countryCode,
              verifyMode: 'sms',
              flag: 'nomatch',
              authSession: authSession,
              phoneId: phoneId,
              // otpChecksum: checksum,
              actionType: 'phoneEnrollment',
              ciamId: this.dialogData.ciamToken,
              secondaryContactId: this.dialogData.contactId,
            },
            panelClass: 'custom-passport-dialog',
          });
          emailDialog.afterOpened().subscribe(() => {
            this.dialogRef.close();
          });
        }, 0);
      },
      error: (err: any) => {
        this.Loader.isSpinner = false;
        this._ToastrApiService.show('error',  "Error occured during Authentication Method Phone.");
      },
    });
  }
}
